<template>
  <div class="d-timetal">
    <div class="d-timetal__container">
      <div class="d-timetal__container__header">
        <h2 class="uppercase">Resume</h2>
      </div>
      <div v-if="isLoadingStilData" style="width: 500px">
        <Loader></Loader>
      </div>
      <template v-else>
        <GrundskoleIndberetningTimetal
          class="marg-1-top"
          :stilData="stilData"
          :isReadOnly="true">
        </GrundskoleIndberetningTimetal>
        <div class="submit-bttn__container">
          <button class="bttn bttn--primary" style="width: 165px" :class="{'bttn--loading': isSendingToStil}"
                  @click="submit">Afslut og indberet
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import docendo from '../../docendo'
import Loader from '../common/Loader'
import ResumePersonaleSkema from './ResumePersonaleSkema'
import eventbus from '../../eventbus'
import GrundskoleIndberetningTimetal from './GrundskoleIndberetningTimetal'
import GrundskoleIndberetningRessourceOverview from './GrundskoleIndberetningRessourceOverview'

export default {
  components: {GrundskoleIndberetningRessourceOverview, GrundskoleIndberetningTimetal, ResumePersonaleSkema, Loader},
  data () {
    return {
      isSendingToStil: false,
      stilData: {},
      isLoadingStilData: true
    }
  },
  computed: {
    users () {
      return this.$store.getters.usersSortedOnName
    },
    schoolId () {
      return this.$route.params.school_id
    },
    ressourceskema () {
      return this.stilData['ressourceskema'] ? this.stilData['ressourceskema'] : []
    },
    undervisningskema () {
      return this.stilData['undervisningskema'] ? this.stilData['undervisningskema'] : []
    }
  },
  methods: {
    submit () {
      this.isSendingToStil = true
      docendo.submitStilReport(this.schoolId, success => {
        this.isSendingToStil = false
        eventbus.toast = {text: 'Grundskoleindberetning er sendt til STIL', 'success': true}
      }, failure => {
        eventbus.toast = {text: 'Noget gik galt', 'success': false}
      })
    }
  },
  mounted () {
    this.isLoadingStilData = true
    docendo.showStilReport(this.schoolId, success => {
      this.isLoadingStilData = false
      this.stilData = success
      console.log('success', success)
    }, failure => {
      console.log('failure')
    })
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.uppercase {
  text-transform: uppercase;
  margin-bottom: 0.5rem;
}

.d-timetal__container {
  padding: 2rem 1rem;
  border: 1px solid #d8d8d8;
  width: 100%;
  max-width: 1440px;
  min-width: 1100px;
  border-radius: 4px;
}

.d-table {
  width: 100%;
  border: 1px solid #d8d8d8;
  border-collapse: collapse;
  border-radius: 4px;
}

.d-table thead {
  border-bottom: 1px solid #d8d8d8;
  background: #f6f9fc;
  color: #728195;
  text-transform: uppercase;
  border-radius: 4px;
  font-size: 11px;
}

.d-table thead th,
.d-table tbody td {
  padding: 0.5rem 1rem;
  text-align: left;
  width: 75px !important;
}

.d-table thead tr th:first-child {
  border-radius: 4px 0 0 0;
}

.d-table tbody tr {
  width: 100%;
  background: #f9fafb;
  border-bottom: 1px solid #e3e8ee;
}

.d-table tbody tr > td:not(:first-child) {
  text-align: center;
}

.d-table tbody tr:nth-child(odd) {
  background: #ffffff;
}

.d-table thead th {
  text-align: center;
}

input.d-input {
  outline: 0 !important;
  border: 1px solid #edf2f7;
  padding: 0.75rem 1rem;
  width: 100%;
  font-size: .85rem;
  margin: 0;
  -webkit-appearance: none !important;
  background-color: rgb(255, 255, 255);
  box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 12%) 0px 1px 1px 0px, rgb(64 68 82 / 16%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(64 68 82 / 8%) 0px 2px 5px 0px;
  box-sizing: border-box !important;
  transition: background-color .24s, box-shadow .24s;
  border-radius: 4px;
  text-align: center;
}

input.d-input:focus {
  border-color: var(--blue) !important;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
  -webkit-appearance: none !important;
}

.d-table thead tr th:first-child,
.d-table tbody tr td:first-child {
  width: 200px !important;
}

.d-table tbody tr:hover {
  background: aliceblue;
}

.d-timetal__container__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.d-summarized {
  font-weight: bold;
  font-size: 1.05rem;
  border-bottom: 1px solid #d8d8d8 !important;
  background: #f6f9fc;
  color: #728195;
}

.submit-bttn__container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// GrundskoleIndberetningResume.vue?14c3496d